<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns="http://www.w3.org/1999/html">
  <div id=mysign>
    <mt-header title="我的签名">
      <mt-button icon="back" slot="left" @click="goBack">返回</mt-button>
    </mt-header>
    <div>
      <div class="flSign createMySign">
        <img @click="createMySign" src="/static/img/user/sign/add.png"/>
        <div><span>创建新签名</span></div>
      </div>
      <ul style="text-align: left">
        <li v-for="(item, index) in itemsSign">
          <div class="flSign mySign">
            <div>
              <img :src="createSrcUrl(item.regurl)"/>
            </div>
            <div class="oper">
              <img class="_check" @click="changeStatus(index,item)" :src="setUrl(index,item)"/>
              <div class="_setInt" v-if="item.isDefault == '1'">取消默认</div>
              <div class="_setInt" v-else-if="item.isDefault != '1'">设为默认</div>
              <img class="_delete_sign" @click="deleteSign(index,item)" src="/static/img/user/sign/delete.png"/>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import {Toast, Indicator} from 'mint-ui';
  export default {
    name: 'mySign',
    data () {
      return {
        serverUrl: domain("_serverUrl"),
        itemsSign: [],
        imgSrcChecked: "/static/img/user/sign/checked.png",
        imgSrcUnChecked: "/static/img/user/sign/unchecked.png",
        errorCode: '',
        _selected: '',
        approveStatus:0
      }
    },
    methods: {
      createMySign: function () {
        var listLength = this.itemsSign.length;
        if(this.approveStatus  == '1'||this.approveStatus  == '7'){
          if (listLength == 6) {
            Toast("签名数已达到上限");
            return;
          }
        }else{
          if (listLength == 5) {
            Toast("签名数已达到上限");
            return;
          }
        }




        this.$router.push({
          path: "/contract/signature",
          name: 'signature',
          query: {
            returnRouterPath: "/main",
            _selected: this._selected,
            seenPage: "1"
          }
        })
      },
      createSrcUrl(regurl){
        return this.serverUrl + regurl;
      },
      fetcchMsg(){
        var _findMySign_url = domain("_findMySign");
        var that = this;
        that.$http.post(
          _findMySign_url,
          {},
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            this.itemsSign = response.data.data.rs;
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      },
      changeStatus(index, item){
        //利用Ajax请求,重新获取签名数据
        var registerSignId = item.registerSignId;
        var _updateSignStatus_url = domain("_updateSignStatus");
        var that = this;
        that.$http.post(
          _updateSignStatus_url,
          {sid: registerSignId},
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            var code = response.data.code;
            if (code == '1') {
              this.$toast("设置成功");
              this.fetcchMsg();
            } else {
              var msg = response.data.msg;
              this.$toast(msg);
            }
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })


      },
      setUrl(index, item){
        var status = item.isDefault;
        if (status == '1') {
          return this.imgSrcChecked;
        } else {
          return this.imgSrcUnChecked;
        }

      },
      deleteSign(index, item){
        //利用Ajax请求,重新获取签名数据
        var registerSignId = item.registerSignId;
        var _deleteSignFile = domain("_deleteSignFile");
        var that = this;
        that.$http.post(
          _deleteSignFile,
          {sid: registerSignId},
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            var code = response.data.code;
            if (code == '1') {
              this.$toast("删除成功");
              this.fetcchMsg();
            } else {
              var msg = response.data.msg;
              this.$toast(msg);
            }

          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      },
      initParams(){
        let params = this.$route.query;
        this._selected = params._selected;
        var _mainIndex_Url = domain("_mainIndex"); //个人中心数据
        this.$http.post(
          _mainIndex_Url,
          {emulateJSON: true}
          )
          .then(function (response) {
             this.approveStatus = response.data.data.approveStatus;
          }, function (error) {
            console.log(error);
          }).catch(function (response) {
          console.log(response);
        })
      },
      goBack: function () {
        history.go(-1); //后退1页
      }
    },
    components: {},
    mounted: function () {
      this.fetcchMsg('a');
      this.initParams();
    }


  }
</script>
<style>
  #mysign {
    background-color: #ECECEC;
    width: 100%;
    min-height: 100%;
  }

  .title {
    position: fixed;
    width: 100%;
    height: 9%;
    background-color: #1f74d8;
    color: #ffffff;
    font-family: "Microsoft YaHei";
    font-size: 1.2rem;
    line-height: 3.5rem;
  }

  .title .left {
    width: 20%;
    display: inline;
    float: left;
  }

  .title .left span {
    margin-left: 1rem;
  }

  .title .mid {
    width: 60%;
    text-align: center;
    float: left;
  }

  .title .right span {
    margin-right: 1rem;
  }

  .flSign {
    margin-left: 4%;
    margin-right: 4%;
    background-color: #ffffff;
    margin-top: 0.5rem;
  }

  .createMySign {
    text-align: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 1.5rem;
    color: #c1c1c1;
    font-family: "Microsoft YaHei";
    border-radius: 5px;
  }

  .createMySign img {
    max-width: 60px;
    max-height: 60px;
  }

  .mySign {
    border-radius: 5px;
  }

  .mySign img {
    display: block;
    margin: auto;
    width: 100px;
  }

  .oper {
    border-top: 1px dashed #d4d4d4;
  }

  .oper img {
    display: block;
    width: 16px;
    height: 16px;
    margin-top: 7px;
  }

  .oper ._check {
    margin-top: 7px;
    margin-left: 7px;
    float: left;
  }

  ._setInt {
    display: inline;
    margin-left: 7px;
    line-height: 2rem;
    color: #7d7d7d;
    font-size: 0.9rem;
  }

  ._delete_sign {
    float: right;
    padding-right: 0.4rem

  }

</style>



// WEBPACK FOOTER //
// src/module/user/mySign.vue